import axios from 'axios'

const http = axios.create({
    baseURL: `${process.env.REACT_APP_API_SERVER_URL}/api/v1`
})

export { http }